import { User } from '../user'

async function getUserData(localRepo) {
  const userData = await localRepo.get()
  if (!userData) return null
  const user = new User()
  user.setData(userData)
  return user
}

export default getUserData
